export default function BlogPostTemplate() {
    return (
        <div class="post-excerpt"></div>
    );
}